
// TODO: add notice somewhere about siteboard using email based passwordless login
// TODO: add to benefits list "sending schedules to email contacts"

import { connect } from 'react-redux';
import { useState, useEffect, useRef } from 'react';

import { ERROR_MESSAGES } from '../errorMessages';
import { login, setLoading, setAlert, siteboardAction } from '../actions/defaultActions';
import { LoginCode, Email, SiteboardApiValidator, UserName, CHECK_TRIAL_SIGNUP_CODE, TRIAL_DURATION_DAYS, CHECK_STANDARD_SIGNUP_CODE,
  STANDARD_SUBSCRIPTION_PRICE_MONTHLY, STANDARD_SUBSCRIPTION_ADDITIONAL_USER_PRICE_MONTHLY, TRIAL_PROJECT_LIMIT, TRIAL_SCHEDULE_LIMIT, REQUEST_TRIAL_SIGNUP_CODE,
  REQUEST_STANDARD_SIGNUP_CODE, Project, User, Subscription, Schedule, SETUP_LOCAL_SESSION, Activity, UUID, ADDITIONAL_USER_DESCRIPTION, PUSH_BROWSER_HISTORY_STATE,
} from '../actions/types';
import { isObject, isArray, getServerApiResponse, uuidv4 } from '../Util';
import { format } from 'date-fns';

import TrialSubscriptionCard from './TrialSubscriptionCard';
import StandardSubscriptionCard from './StandardSubscriptionCard';
import LoginDialogue from './LoginDialogue';
import PoweredByBar from './PoweredByBar';
import ParallaxSection from './ParallaxSection';
import Tooltip from './Tooltip';
import PushButton from './PushButton';

import Logo from '../SiteBoard_Logo';
import ExpandDownIcon from '../icons/expandDownIcon';
import GantChartIcon from '../icons/gantChartIcon';
import BackIcon from '../icons/backIcon';
import CrewIcon from '../icons/crewIcon';
import TimeIcon from '../icons/timeIcon';
import MoneyIcon from '../icons/moneyIcon';
import ChecklistIcon from '../icons/checklistIcon';
import AddIcon from '../icons/addIcon';
import CircleCheckIcon from '../icons/circleCheckIcon';
import LandingPagePeopleIcon from '../icons/landingPagePeopleIcon';
import LandingPageEyeIcon from '../icons/landingPageEyeIcon';
import LandingPageBellIcon from '../icons/landingPageBellIcon';
import LandingPageSuperintendentIcon from '../icons/landingPageSuperintendentIcon';
import LandingPageClockIcon from '../icons/landingPageClockIcon';
import LandingPageShareIcon from '../icons/landingPageShareIcon';
import LandingPageGraphIcon from '../icons/landingPageGraphIcon';
import LandingPageQuoteIcon from '../icons/landingPageQuoteIcon';
import LandingPageUnderline2Icon from '../icons/landingPageUnderline2Icon';
import TagIcon from '../icons/tagIcon';

const PAGE_LANDING = 'PAGE_LANDING';
const PAGE_TRIAL_SIGNUP = 'PAGE_TRIAL_SIGNUP';
const PAGE_TRIAL_LOGIN_CODE = 'PAGE_TRIAL_LOGIN_CODE';
const PAGE_TRIAL_LOGIN_LINK = 'PAGE_TRIAL_LOGIN_LINK';
const PAGE_STANDARD_SIGNUP = 'PAGE_STANDARD_SIGNUP';
const PAGE_STANDARD_LOGIN_CODE = 'PAGE_STANDARD_LOGIN_CODE';
const PAGE_STANDARD_LOGIN_LINK = 'PAGE_STANDARD_LOGIN_LINK';
const PAGE_SIGNUP_PLANS = 'PAGE_SIGNUP_PLANS';

const LandingPage = ({_isTouchDevice, _localEditScheduleId, _localEditScheduleProjectId, setAlert, login, setLoading, siteboardAction}) => {
  const inputStyle = 'w-full text-white rounded-md px-3 py-1.5 bg-[#444247] hover:bg-[#656565] focus:bg-[#656565]';

  const [currentPage, setCurrentPage] = useState(PAGE_LANDING);
  const [loginDialogueShowing, setLoginDialogueShowing] = useState(false);
  const [inputFirstName, setInputFirstName] = useState('');
  const [inputLastName, setInputLastName] = useState('');
  const [inputEmail, setInputEmail] = useState('');
  const [inputCompanyName, setInputCompanyName] = useState('');
  const [inputLoginCode, setInputLoginCode] = useState('');

  const trialLoginCodeRef = useRef(null);
  const standardLoginCodeRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  // Helper keys to switch screens for testing
  useEffect(() => {
    if(process.env.REACT_APP_LIVE_MODE === 'true') return;

    const onKeyUp = (event) => {
      if(event.key === 'ArrowLeft') { 
        if(currentPage === PAGE_TRIAL_SIGNUP || currentPage === PAGE_STANDARD_SIGNUP) {
          setCurrentPage(PAGE_LANDING);
        } else if(currentPage === PAGE_TRIAL_LOGIN_CODE || currentPage === PAGE_TRIAL_LOGIN_LINK) {
          setCurrentPage(PAGE_TRIAL_SIGNUP);
        } else if(currentPage === PAGE_STANDARD_LOGIN_CODE || currentPage === PAGE_STANDARD_LOGIN_LINK) {
          setCurrentPage(PAGE_STANDARD_SIGNUP);
        }
        setInputEmail('');
      } else if(event.key === 'ArrowRight') { 
        if(currentPage === PAGE_TRIAL_SIGNUP) {
          setCurrentPage(PAGE_TRIAL_LOGIN_CODE);
        } else if(currentPage === PAGE_STANDARD_SIGNUP) {
          setCurrentPage(PAGE_STANDARD_LOGIN_CODE);
        }
        setInputEmail('keyright@keyright');
      } else if(event.key === 'ArrowDown') { 
        if(currentPage === PAGE_TRIAL_SIGNUP) {
          setCurrentPage(PAGE_TRIAL_LOGIN_LINK);
        } else if(currentPage === PAGE_STANDARD_SIGNUP) {
          setCurrentPage(PAGE_STANDARD_LOGIN_LINK);
        }
        setInputEmail('keydown@keydown');
      } 
    };

    window.addEventListener('keyup', onKeyUp);
    return () => { window.removeEventListener('keyup', onKeyUp); }; // remove listener when component unloads
  }, [currentPage]);

  // focus signup code input when component is shown
  useEffect(() => {
    // Don't auto focus for touch devices because it changes the screen layout too much when the virtual keyboard appears
    if(_isTouchDevice === true) return;

    setInputLoginCode('');
    if(currentPage === PAGE_TRIAL_LOGIN_CODE) {
      if(trialLoginCodeRef.current) {
        trialLoginCodeRef.current.select();
      }
    } else if(currentPage === PAGE_STANDARD_LOGIN_CODE) {
      if(standardLoginCodeRef.current) {
        standardLoginCodeRef.current.select();
      }
    } 
  }, [currentPage, _isTouchDevice]);

  const onTrialClicked = () => {
    setCurrentPage(PAGE_TRIAL_SIGNUP);
    //siteboardAction(PUSH_BROWSER_HISTORY_STATE, {});
    window.scrollTo(0, 0);
  };
  const onStandardClicked = () => {
    setCurrentPage(PAGE_STANDARD_SIGNUP);
    window.scrollTo(0, 0);
  };

  const requestSignupCode = (signupAction) => {
    let validInput = null;
    try {
      validInput = SiteboardApiValidator[signupAction].validateInput({ 
        action: signupAction,
        email: inputEmail,
        firstName: inputFirstName,
        lastName: inputLastName,
      });
      if (validInput.firstName.length === 0) throw new Error('Please enter your first name');
      if (validInput.lastName.length === 0) throw new Error('Please enter your last name');
    } 
    catch(error) { 
      setAlert(error.message); 
      return;
    }

    const onApiSuccess = (data) => {
      setLoading('');
      if(data.action === 'loginCodeEmailed') {
        if(signupAction === REQUEST_TRIAL_SIGNUP_CODE) {
          setCurrentPage(PAGE_TRIAL_LOGIN_CODE);
        } else if(signupAction === REQUEST_STANDARD_SIGNUP_CODE) {
          setCurrentPage(PAGE_STANDARD_LOGIN_CODE);
        } 
      } else if(data.action === 'loginLinkEmailed') {
        if(signupAction === REQUEST_TRIAL_SIGNUP_CODE) {
          setCurrentPage(PAGE_TRIAL_LOGIN_LINK);
        } else if(signupAction === REQUEST_STANDARD_SIGNUP_CODE) {
          setCurrentPage(PAGE_STANDARD_LOGIN_LINK);
        } 
      } else {
        setAlert(ERROR_MESSAGES.LOGIN);
        return;
      }
    };
    const onApiError = (errorMessage) => {
      setLoading('');
      setAlert(typeof errorMessage === 'string' ? errorMessage : ERROR_MESSAGES.LOGIN);
    };

    setLoading('Emailing Your Verification Code');
    getServerApiResponse(validInput, onApiSuccess, onApiError);
  };

  const submitSignupCode = (action) => {
    let validInput = null;
    try {
      validInput = SiteboardApiValidator[action].validateInput({
        action: action,
        email: inputEmail,
        loginCode: inputLoginCode,
        firstName: inputFirstName,
        lastName: inputLastName,
      });
    } 
    catch(error) { 
      setAlert(error.message); 
      return;
    }

    const onApiSuccess = (data) => {
      setLoading('');
      try {
        if (!isObject(data.user) || typeof data.sessionKey !== 'string') throw new Error();
        login(data.user, data.sessionKey); 
      } catch(error) {
        setAlert(ERROR_MESSAGES.LOGIN_CODE);
      }
    };
    const onApiError = (errorMessage) => {
      setLoading('');
      setAlert(typeof errorMessage === 'string' ? errorMessage : ERROR_MESSAGES.LOGIN_CODE);
    };
    setLoading(action === CHECK_TRIAL_SIGNUP_CODE ? 'Activating Your Trial Subscription' : 'Checking Verification Code');
    getServerApiResponse(validInput, onApiSuccess, onApiError);
  };

  const faqs = [
    {
      question: 'What is a 3-week lookahead?',
      answer: ['A 3-week lookahead is a short-term planning tool commonly used in construction to outline upcoming work activities over the next few weeks. These schedules help general contractors, owners, design teams, and other project stakeholders stay aligned on what’s happening on-site. Lookaheads often contain details that may not appear on the master project schedule.', 'Although called a "3-week lookahead," they are typically updated weekly to reflect real-time changes and help teams stay ahead of potential issues.']
      }, 
    {
      question: 'Will SiteBoard replace my global project scheduling software?',
      answer: ['No. SiteBoard is not designed to replace or compete with tools like Primavera P6 or Microsoft Project. Those platforms are excellent for managing global construction schedules but often fall short when it comes to capturing short-term, day-to-day details.', 'For example, if the Owner is delivering OFCI equipment, or if a plumber hits a water line that requires immediate repair, these types of short-term activities are typically tracked in a 3-week lookahead but may not appear on the global schedule.', 'If your team currently uses Excel or Google Sheets for your lookaheads, SiteBoard was built to replace those cumbersome spreadsheets and provide a faster, clearer, and more efficient way to create and update your 3-week lookaheads.']
    },
    {
      question: 'Is there a free version I can try?',
      answer: ['Yes! We offer a '+TRIAL_DURATION_DAYS+'-day free trial. This gives you and your team plenty of time to test SiteBoard and see how it works for your projects.']
    },
    {
      question: 'What is an additional user?',
      answer: [ADDITIONAL_USER_DESCRIPTION]
    },
    {
      question: 'Can I share my 3-week schedules with others?',
      answer: ['Absolutely. SiteBoard includes 1-click PDF generation so you can quickly email your schedules. You can also invite team members to your project directly within SiteBoard. With built-in user roles and permissions, your team can securely access and collaborate on schedules.']
    },
    {
      question: 'Can I import my existing spreadsheets into SiteBoard?',
      answer: ['No. We recommend keeping your existing spreadsheets for record-keeping. To start fresh with SiteBoard, simply re-populate your lookahead schedule within our platform, or create new, just once. From there, updates are quick and hassle-free.']
    },
    {
      question: 'Can I export my SiteBoard schedules to Excel?',
      answer: ['Not at this time. However, SiteBoard offers 1-click PDF exports so you can easily share your lookahead schedules in a professional, easy-to-read format. Additional export options may be available in future updates.']
    },
    {
      question: 'My team already uses Excel or Google Sheets for 3-week schedules. Why switch to SiteBoard?',
      answer: ['We hear this often. Spreadsheets are flexible but were never designed for building and updating 3-week lookaheads. Manually formatting cells, copying, pasting, and color-coding updates can be tedious and time-consuming, especially for those less comfortable with spreadsheets.', 'SiteBoard removes those manual steps. Once your schedule is built in SiteBoard, updates take just minutes. Plus, because SiteBoard is web-based, you can manage your schedules from anywhere, on your phone, tablet, or computer.']
    },
    {
      question: 'How many schedules can I create with SiteBoard?',
      answer: ['During your free '+TRIAL_DURATION_DAYS+'-day trial, you can create up to '+TRIAL_PROJECT_LIMIT+' projects with a combined total of '+TRIAL_SCHEDULE_LIMIT+' schedules. Subscribing unlocks unlimited projects and unlimited schedules.']
    },
    {
      question: 'Can I use SiteBoard from my phone or tablet?',
      answer: ['Yes. SiteBoard is designed to work seamlessly on computers, tablets, and smartphones. You just need an internet connection to access and manage your schedules from anywhere.']
    },
    {
      question: 'What types of companies is SiteBoard designed for?',
      answer: ['SiteBoard was built for construction companies of all sizes, whether you\'re managing large-scale commercial projects or smaller residential builds. If your team runs 3-week lookaheads and you\'re tired of spreadsheets, SiteBoard simplifies the process and keeps everyone aligned.']
    },
    {
      question: 'Does SiteBoard require training to use?',
      answer: ['Not at all. SiteBoard was designed with simplicity in mind. If you’ve used spreadsheets before, you’ll find SiteBoard intuitive and easy to navigate. We also provide quick-start resources and tutorials to get your team up and running in minutes.']
    },
    {
      question: 'Is SiteBoard secure?',
      answer: ['Yes. We take data security seriously. SiteBoard is a web-based platform with secure, encrypted connections to protect your project information. Only users you invite to your project will have access to your schedules.']
    },
    {
      question: 'Do I need to download an app to use SiteBoard?',
      answer: ['No downloads required. SiteBoard is completely web-based. You can access your account from any device with an internet connection, whether you\'re in the office, on-site, or on the go.']
    },
    {
      question: 'Can I use SiteBoard for more than 3-week schedules?',
      answer: ['While SiteBoard is purpose-built for 3-week lookaheads, many teams also use it to track other short-term milestones or internal planning needs. We’ll be expanding functionality based on user feedback.']
    },
  ];

  const FAQItem = ({question, answer}) => {
    const answerRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [answerHeight, setAnswerHeight] = useState('0px');

    return (
    <div className='flex flex-col'>
      <button 
        className='group flex justify-between items-start gap-2 py-4'
        onClick={() => {
          const newIsOpen = !isOpen;
          if(newIsOpen) {
            if(answerRef.current) {
              setAnswerHeight(answerRef.current.scrollHeight+'px');
            }
          } else {
            setAnswerHeight('0px');
          }
          setIsOpen(newIsOpen);
        }}
      >
        <div className='font-semibold group-hover:text-[#f9a928] text-left'>{question}</div>
        <div className={`translate-y-[30%] transition-transform duration-300 ${isOpen ? 'rotate-[45deg]' : 'rotate-[0deg]'}`}>
          <div className='group-hover:hidden'><AddIcon color='#fff' /></div>
          <div className='hidden group-hover:block'><AddIcon color='#f9a928' /></div>
        </div>
      </button>
      <div 
        ref={answerRef}
        style={{
          maxHeight: answerHeight,
          transition: 'max-height 0.3s ease',
        }}
        className={`flex flex-col gap-4 overflow-hidden`}
      >
        {answer.map((answerLine, index) => (
          <div key={index} className='last:mb-4 text-[#ccc]'>{answerLine}</div>
        ))}
      </div>
      <div className='grow'></div>
      <div className='h-[1px] w-full bg-[#888]'></div>
    </div>
    );
  };

  const getMainPageJSX = () => {
    return (
      <>
        <div className='relative z-[1] flex flex-col mx-auto gap-y-6 w-full pb-[10vh]'>
          <div className='relative z-[1] flex justify-between items-start p-4'>
            {/* SiteBoard logo */}
            <button 
              className={'flex items-center gap-x-2 font-bold text-[1.8em]'}
              onClick={() => {
                try { setCurrentPage(PAGE_LANDING); } catch(error) {}
              }}
            >
              <Logo size={'1em'} />
              {process.env.REACT_APP_WEBSITE_NAME} 
            </button>
            <div className='flex justify-end'>
              {currentPage === PAGE_LANDING &&
              <PushButton 
                textColor='black'
                bgColor='#f9a928'
                hoverBgColor='#f79800'
                onClick={() => { setLoginDialogueShowing(true); }}
              >
                <div className='px-6 text-lg'>Log in</div>
              </PushButton>
              }
            </div>
          </div>
          <div className='flex flex-col items-start gap-y-8 w-[85vw] pt-[4vh] max-w-screen-xl mx-auto'>
            <div className='flex flex-col items-start gap-y-4 md:text-[1.2em] lg:text-[1.4em]'>
              <div className='flex flex-col leading-[2.4em]'>
                <div className='text-white font-bold text-[2.4em]'>Get your</div>
                <div className='text-white font-bold text-[2.2em]'><span className='text-[#f9a928]'>subs</span> on the <div className='inline relative'>board<div className='absolute left-1/2 translate-x-[-50%] top-full'><LandingPageUnderline2Icon size='0.4em' /></div></div>.</div>
              </div>
              <div className='text-white font-bold text-[1.6em]'>Keep your job on track.</div>
              <div className='max-w-[270px] font-medium md:max-w-[350px] lg:max-w-[400px] leading-tight [text-shadow:0_2px_6px_rgba(0,0,0,0.99)]'>Share your 3-week lookahead, track who sees it, and make sure everyone shows up when they're supposed to.</div>
            </div>
            <div>
              <PushButton 
                isInline={true}
                textColor='black'
                bgColor='#f9a928'
                hoverBgColor='#f79800'
                onClick={() => { 
                  setCurrentPage(PAGE_SIGNUP_PLANS); 
                  //siteboardAction(PUSH_BROWSER_HISTORY_STATE, {}, (validOutput) => {
                  //  console.log(validOutput.stateId);
                  //});
                }}
              >
                <div className='text-[1.4em]'>Create My 3-Week Schedule</div>
              </PushButton>
            </div>
            <div className='flex gap-2 items-center [text-shadow:0_2px_6px_rgba(0,0,0,0.99)]'>
              <CircleCheckIcon color='#f9a928' />
              <div>Free to try.</div>
              <div className='text-[#f9a928]'>No credit card required.</div>
            </div>
          </div>
          {/* top right floating logo */}
          <div className='absolute z-[-1] top-[6em] left-[40%] translate-x-[-50%] opacity-[0.15] pointer-events-none'>
            <div className='sm:hidden'><Logo size={250} /></div>
            <div className='hidden sm:block 2xl:hidden'><Logo size={400} /></div>
            <div className='hidden 2xl:block'><Logo size={400} /></div>
          </div>
          {/* hero construction site background */}
          <img width='1154' height='750' className='z-[-2] absolute top-0 left-0 w-full h-full object-cover object-center' src='/images/siteboard_landing_page_image_2026-06-14.jpg' alt='a construction site' />
          <div className='z-[-1] sm:hidden absolute top-0 left-0 w-full h-full bg-[#00000030]'/>
          <div className='absolute bottom-[0%] left-0 h-[5vh] w-[100vw] bg-gradient-to-t from-[#0c0e0d] to-[#0c0e0d00]'></div>
        </div>
        <div className='relative z-[1]'>
          <div className='w-[92vw] py-6 max-w-screen-xl mx-auto'>
            <div className='grid grid-cols-2 min-[750px]:grid-cols-4 gap-x-2 gap-y-12 sm:gap-4 pt-2 mx-1 rounded-b-lg justify-items-center place-items-start w-full'>
              <div className='flex flex-col items-start gap-3 w-[150px] sm:w-[160px]'>
                <LandingPagePeopleIcon size='4em' />
                <div className='text-lg font-bold leading-tight'>Everyone knows the plan</div>
                <div className='leading-tight'>Share your schedule in one click.</div>
              </div>
              <div className='flex flex-col items-start gap-3 w-[150px] sm:w-[160px]'>
                <LandingPageEyeIcon size='4em' />
                <div className='text-lg font-bold leading-tight'>See who viewed and confirmed</div>
                <div className='leading-tight'>No more wondering who saw it.</div>
              </div>
              <div className='flex flex-col items-start gap-3 w-[150px] sm:w-[160px]'>
                <LandingPageBellIcon size='4em' />
                <div className='text-lg font-bold leading-tight'>Fewer surprises. More showing up.</div>
                <div className='leading-tight'>Reduce delays and keep your job moving.</div>
              </div>
              <div className='flex flex-col items-start gap-3 w-[150px] sm:w-[160px]'>
                <LandingPageSuperintendentIcon size='4em' />
                <div className='text-lg font-bold leading-tight'>Built for superintendents</div>
                <div className='leading-tight'>Fast, simple, and built for the field.</div>
              </div>
            </div>
            <div className='flex flex-col justify-between items-center gap-2 bg-white rounded-2xl mt-12 text-black inline'>
              <div className='flex flex-col justify-between items-center gap-1 p-6'>
                {/*<div className='text-[#fd8101] font-bold'>SEE IT IN ACTION</div>*/}
                <div className='font-bold text-2xl text-center'>Build a 3-Week Lookahead in 3 Minutes</div>
                <div className=''>Watch our step-by-step tutorial and see how easy it is to build, publish, and share your schedule with {process.env.REACT_APP_WEBSITE_NAME}.</div>
              </div>
              <div className="relative w-full overflow-hidden bg-black shadow-sm aspect-video">
                <iframe
                  className="absolute inset-0 h-full w-full border-0"
                  src='https://www.youtube.com/embed/wu_L6hZHTFY'
                  title='SiteBoard Tutorial: Build a 3-Week Lookahead in 3 Minutes'
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  referrerPolicy="strict-origin-when-cross-origin"
                />
              </div> 
              <div className='flex flex-col md:flex-row justify-between items-center gap-6 p-6'>
                <div className='flex flex-col justify-start items-start gap-3 '>
                  <LandingPageQuoteIcon size='2em' />
                  <div className='flex flex-col justify-start items-start gap-2'>
                    <div className='italic font-medium'>Before {process.env.REACT_APP_WEBSITE_NAME}, I never new if subs would actually show up when I needed them.</div>
                    <div className='flex gap-3 self-end mr-6'><b>Rick</b> <div>- Superintendent in Texas</div></div>
                  </div>
                </div>
                <div className='flex flex-col items-center gap-3 '>
                  <LandingPageClockIcon size='4em' />
                  <div className='text-lg font-bold leading-tight text-center'>Save hours</div>
                  <div className='leading-tight text-center'>Build your own 3-week lookahead in minutes.</div>
                </div>
                <div className='flex flex-col items-center gap-3 '>
                  <LandingPageShareIcon size='4em' />
                  <div className='text-lg font-bold leading-tight text-center'>Share instantly</div>
                  <div className='leading-tight text-center'>One link. Everyone stays in the loop.</div>
                </div>
                <div className='flex flex-col items-center gap-3 '>
                  <LandingPageGraphIcon size='4em' />
                  <div className='text-lg font-bold leading-tight text-center'>Stay in control</div>
                  <div className='leading-tight text-center'>From the office or on the jobsite.</div>
                </div>
              </div>
            </div>
          </div>
          <div className='flex flex-col gap-12 w-[85vw] py-6 max-w-screen-md mx-auto mt-6'>
            <div className='flex gap-6 items-start'>
              <div className='lg:hidden'><LandingPageClockIcon size='2.4em' /></div>
              <div className='hidden lg:block'><LandingPageClockIcon size='4em' /></div>
              <div className='text-[2em] lg:text-[2.4em] font-semibold leading-tight'>Build professional 3-week lookahead schedules in minutes.</div>
            </div>
            <div className='flex gap-6 items-start'>
              <div className='lg:hidden'><LandingPageBellIcon size='2.4em' /></div>
              <div className='hidden lg:block'><LandingPageBellIcon size='4em' /></div>
              <div className='text-[2em] lg:text-[2.4em] font-semibold leading-tight'>Keep every trade informed with automatic notifications.</div>
            </div>
            <div className='flex gap-6 items-start'>
              <div className='lg:hidden opacity-0'><LandingPageClockIcon size='2.4em' /></div>
              <div className='hidden lg:block opacity-0'><LandingPageClockIcon size='4em' /></div>
              <div className='text-[2em] lg:text-[2.4em] font-semibold leading-tight'>Spend less time coordinating and more time building with <div className='relative inline'>{process.env.REACT_APP_WEBSITE_NAME}<div className='absolute left-1/2 translate-x-[-50%] top-full'><LandingPageUnderline2Icon size='0.55em' /></div></div>.</div> 
            </div>
          </div>
          <div className='flex justify-center text-[1.4em] mt-12 mb-[15vh] w-[92vw] max-w-screen-sm mx-auto'>
            <PushButton 
              textColor='black'
              bgColor='#f9a928'
              hoverBgColor='#f79800'
              onClick={() => { 
                setCurrentPage(PAGE_TRIAL_SIGNUP);
              }}
            >
              Start Free Trial
            </PushButton>
          </div>
          {/* bottom right floating logo */}
          <div className='absolute z-[-1] bottom-[6em] left-[100%] translate-x-[-80%] opacity-[0.15] pointer-events-none'>
            <div className='sm:hidden'><Logo size={250} /></div>
            <div className='hidden sm:block 2xl:hidden'><Logo size={400} /></div>
            <div className='hidden 2xl:block'><Logo size={400} /></div>
          </div>
          {/* bottom construction site background */}
          <img width='1000' height='667' className='z-[-2] absolute top-0 left-0 w-full h-full object-cover object-top' src='/images/landing_page_image_2.jpg' alt='a construction site' />
          <div className='absolute bottom-[0%] left-0 h-[8vh] w-[100vw] bg-gradient-to-t from-[#151515] to-[#15151500]'></div>
        </div>
        <div className={'flex flex-col items-center gap-y-[30px] text-[1.2em] my-12 w-[92vw] max-w-screen-lg mx-auto'}>
          <div className='text-white font-bold text-[1.8em] sm:text-[2.2em] 2xl:text-[2.6em] text-center leading-[1.3em]'>Frequently Asked Questions</div>
          <div className='grid grid-cols-1 sm:grid-cols-2 gap-x-6'>
            {faqs.map((faq, index) => (
              <FAQItem key={index} question={faq.question} answer={faq.answer} /> 
            ))}
          </div>
        </div>
        <div className={'flex flex-col gap-6 text-[1.2em] my-12 w-[92vw] max-w-screen-lg mx-auto'}>
          <div className='text-white font-bold text-[1.8em] sm:text-[2.2em] 2xl:text-[2.6em] text-center leading-[1.3em]'>Learn from {process.env.REACT_APP_WEBSITE_NAME}</div>
          <div className='text-white'>{process.env.REACT_APP_WEBSITE_NAME} Presents is a podcast for construction professionals who want to simplify the way they manage projects and communicate with their teams.</div>
          <div className='flex flex-col gap-2'>
            <div className='text-[1.2em] font-medium'>Latest Episode <span className='font-normal text-base opacity-70'>(listen on Spotify)</span></div>
            <a className='flex flex-col items-start gap-2 p-4 rounded-2xl bg-[#222] hover:bg-[#444]' href='https://open.spotify.com/episode/2NylYJ28Vl488pam7zlTHr?si=voao0RJHQAyZfk4GeMWs1g' target="_blank" rel="noopener noreferrer">
              <div className='flex gap-2 items-center'>
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-green-500">
                  <div className="ml-0.5 w-0 h-0 border-y-[5px] border-y-transparent border-l-[8px] border-l-black"></div>
                </div>
                <div className='inline-block font-bold'>Why We Built {process.env.REACT_APP_WEBSITE_NAME}</div>
              </div>
              <div className='text-white opacity-70'>In this episode, we take you behind the scenes of why we built {process.env.REACT_APP_WEBSITE_NAME}, who it's designed for, and how we believe it can make your day-to-day work easier, more organized, and more efficient.</div>
            </a>
          </div>
        </div>
        <div className='z-[1]'>
          <PoweredByBar />
        </div>
      </>
    );
  };

  const getSignupPagesJSX = () => {
    return (
      <div className={`relative flex flex-col justify-between min-h-screen bg-[#151515] text-white overflow-hidden`}>
        <div className='relative z-[1] flex justify-between p-4'>
          {/* SiteBoard logo */}
          <button 
            className={'flex items-center gap-x-2 font-bold text-[1.8em]'}
            onClick={() => {
              try { setCurrentPage(PAGE_LANDING); } catch(error) {}
            }}
          >
            <Logo size={'1em'} />
            {process.env.REACT_APP_WEBSITE_NAME} 
          </button>
          <div className='flex justify-end'></div>
        </div>
        {currentPage === PAGE_SIGNUP_PLANS &&
          <div className='relative z-[1] grow flex flex-col justify-center items-center max-w-screen-lg px-2 text-[1.2em] w-full animate-right-fade mx-auto'>
            <div className='grow flex flex-col justify-center items-center max-w-[450px] mt-[20px] w-full gap-4'>
              <div className='text-white font-bold text-[1.8em] sm:text-[2.2em] 2xl:text-[2.6em] text-center leading-[1.3em]'>Pricing Plans</div>
              <div className='flex flex-col md:flex-row gap-y-[20px] gap-x-[20px]'>
                <TrialSubscriptionCard onClicked={onTrialClicked} />
                <StandardSubscriptionCard onClicked={onStandardClicked} />
              </div>
            </div>
            {/* Back button */}
            <div className='w-full mt-8 pb-5'>
              <button 
                className='group flex justify-center items-center gap-x-2' 
                title='Go Back'
                onClick={() => { 
                  try { setCurrentPage(PAGE_LANDING); } catch(error) {}
                }}
              >
                <div className='group-hover:hidden'><BackIcon color='#a59e9e' /></div>
                <div className='hidden group-hover:block'><BackIcon color='#fff' /></div>
                <div className='text-[#a59e9e] group-hover:text-white'>Back</div>
              </button>
            </div>
          </div>
        }
        {currentPage === PAGE_TRIAL_SIGNUP &&
          <div className='relative z-[1] grow flex flex-col justify-center items-center max-w-screen-lg px-2 text-[1.2em] w-full animate-right-fade mx-auto'>
            <div className='grow flex flex-col justify-center items-center max-w-[500px] mt-[20px] w-full'>
              <div className='flex flex-col gap-y-8 w-full'>
                <div className='flex flex-col gap-y-2 w-full'>
                  <div className='font-bold text-[1.8em] sm:text-[2.2em] 2xl:text-[2.6em] text-white text-left leading-[1em]'>Try {process.env.REACT_APP_WEBSITE_NAME} Free</div>
                  <div className='flex flex-col gap-1 items-start italic'>
                    <div>Full access for {TRIAL_DURATION_DAYS} days.</div>
                    <div>No credit card required. Cancel anytime.</div>
                    <div>Your information is secure and will never be shared.</div>
                  </div>
                </div>
                <div className='flex flex-col gap-y-6'>
                  {/* First and Last name */}
                  <div className='flex gap-x-2'>
                    <div>
                      <label className='block text-sm font-medium mb-1'>First Name</label>
                      <div className='rounded-[12px] border border-[#0000003f] h-[32px] '>
                        <input 
                          value={inputFirstName}
                          className={inputStyle}
                          type='text' 
                          onChange={(event) => { setInputFirstName(event.target.value); }}
                          onKeyDown={(event) => { if(event.key === 'Enter') { requestSignupCode(REQUEST_TRIAL_SIGNUP_CODE); } }}
                        />
                      </div>
                    </div>
                    <div>
                      <label className='block text-sm font-medium mb-1'>Last Name</label>
                      <div className='rounded-[12px] border border-[#0000003f] h-[32px] '>
                        <input 
                          value={inputLastName}
                          className={inputStyle}
                          type='text' 
                          onChange={(event) => { setInputLastName(event.target.value); }}
                          onKeyDown={(event) => { if(event.key === 'Enter') { requestSignupCode(REQUEST_TRIAL_SIGNUP_CODE); } }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Email Input */}
                  <div>
                    <label className='block text-sm font-medium mb-1'>Work Email</label>
                    <div className='rounded-[12px] border border-[#0000003f] h-[32px] '>
                      <input 
                        value={inputEmail}
                        className={inputStyle}
                        type='text' 
                        onChange={(event) => { setInputEmail(event.target.value); }}
                        onKeyDown={(event) => { if(event.key === 'Enter') { requestSignupCode(REQUEST_TRIAL_SIGNUP_CODE); } }}
                      />
                    </div>
                  </div>
                  {/* Company Name Input */}
                  {/*<div>
                    <label className='block text-sm font-medium mb-1'>Company Name</label>
                    <div className='rounded-[12px] border border-[#0000003f] h-[32px] '>
                      <input 
                        value={inputCompanyName}
                        className={inputStyle}
                        type='text' 
                        onChange={(event) => { setInputCompanyName(event.target.value); }}
                        onKeyDown={(event) => { if(event.key === 'Enter') { requestSignupCode(REQUEST_TRIAL_SIGNUP_CODE); } }}
                      />
                    </div>
                  </div>*/}
                  {/* submit email button */}
                  <PushButton 
                    textColor='black'
                    bgColor='#f9a928'
                    hoverBgColor='#f79800'
                    onClick={() => { requestSignupCode(REQUEST_TRIAL_SIGNUP_CODE); }}
                  >
                    Continue
                  </PushButton>
                </div>
              </div>
            </div>

            {/* Back button */}
            <div className='w-full mt-8 pb-5'>
              <button 
                className='group flex justify-center items-center gap-x-2' 
                title='Go Back'
                onClick={() => { 
                  try { setCurrentPage(PAGE_SIGNUP_PLANS); } catch(error) {}
                }}
              >
                <div className='group-hover:hidden'><BackIcon color='#a59e9e' /></div>
                <div className='hidden group-hover:block'><BackIcon color='#fff' /></div>
                <div className='text-[#a59e9e] group-hover:text-white'>Back</div>
              </button>
            </div>
          </div>
        }
        {currentPage === PAGE_TRIAL_LOGIN_CODE &&
          <div className='relative z-[1] grow flex flex-col justify-center items-center max-w-screen-lg w-full mx-auto text-[1.2em] px-2 pb-0 animate-right-fade'>
            <div className='grow flex flex-col justify-center gap-y-6 max-w-[350px]'>
              <div className='text-[1.8em] text-white font-bold text-left'>Check Your Email</div>
              {/* login code input */}
              <div className='max-w-full flex flex-col gap-y-4 mx-auto'>
                <div className='flex flex-col gap-3 mt-[4px]'>
                  <div>
                    <div>We've sent a verification code to</div>
                    <div className='font-bold'>{inputEmail}</div>
                  </div>
                  <div>Enter it below to continue</div>
                </div>
                <div className='font-light opacity-60 mx-auto'>Didn&apos;t receive the code? Check your spam folder or wait up to 2 minutes for delivery.</div>
                <div>
                  <label className='block text-sm font-medium mb-1'>Verification Code</label>
                  <input 
                    ref={trialLoginCodeRef}
                    value={inputLoginCode}
                    className={inputStyle + ' text-center'}
                    type='text' 
                    onChange={(event) => { setInputLoginCode(event.target.value); }}
                    onKeyDown={(event) => { if(event.key === 'Enter') { submitSignupCode(CHECK_TRIAL_SIGNUP_CODE); } }}
                  />
                </div>
                {/* submit login code button */}
                <PushButton 
                  textColor='white'
                  bgColor='#471cff'
                  hoverBgColor='#603aff'
                  onClick={() => { submitSignupCode(CHECK_TRIAL_SIGNUP_CODE); }}
                >
                  Continue
                </PushButton>
                <button 
                  className='mt-2 underline'
                  onClick={() => { 
                    requestSignupCode(REQUEST_TRIAL_SIGNUP_CODE); 
                    setInputLoginCode('');
                    //if(trialLoginCodeRef.current) {
                    //  trialLoginCodeRef.current.select();
                    //}
                  }}
                >
                  Resend code
                </button>
              </div>
            </div>

            {/* Back Button */}
            <div className='pb-5 w-full'>
              <button 
                className='self-start group flex justify-center items-center gap-x-2' 
                onClick={() => { 
                  try { setCurrentPage(PAGE_TRIAL_SIGNUP); } catch(error) {}
                }}
              >
                <div className='group-hover:hidden'><BackIcon color='#a59e9e' /></div>
                <div className='hidden group-hover:block'><BackIcon color='#fff' /></div>
                <div className='text-[#a59e9e] group-hover:text-white'>Back</div>
              </button>
            </div>
          </div>
        }
        {currentPage === PAGE_TRIAL_LOGIN_LINK &&
          <div className='relative z-[1] grow flex flex-col justify-center items-center max-w-screen-lg w-full mx-auto text-[1.2em] px-2 pb-0 animate-right-fade'>
            <div className='grow flex flex-col justify-center gap-y-6 max-w-[350px]'>
              <div className='text-[1.8em] text-white font-bold text-left'>Check Your Email</div>
              <div className='w-[300px] max-w-full flex flex-col gap-y-4 mx-auto'>
                <div>We've sent an email to <b>{inputEmail}</b> containing a secure link to complete the account creation process. Please check your inbox and follow the provided link to finalize your account setup.</div>
                <div className='font-light opacity-50 mx-auto'>Didn&apos;t receive the email? Check your spam folder or wait up to 2 minutes for delivery.</div>
              </div>
            </div>
            {/* Back Button */}
            <div className='pb-5 w-full'>
              <button 
                className='self-start group flex justify-center items-center gap-x-2' 
                onClick={() => { 
                  try { setCurrentPage(PAGE_TRIAL_SIGNUP); } catch(error) {}
                }}
              >
                <div className='group-hover:hidden'><BackIcon color='#a59e9e' /></div>
                <div className='hidden group-hover:block'><BackIcon color='#fff' /></div>
                <div className='text-[#a59e9e] group-hover:text-white'>Back</div>
              </button>
            </div>
          </div>
        }
        {currentPage === PAGE_STANDARD_SIGNUP &&
          <div className='relative z-[1] grow flex flex-col justify-center items-center max-w-screen-lg px-2 text-[1.2em] w-full animate-right-fade mx-auto'>
            <div className='grow flex flex-col justify-center items-center max-w-[500px] mt-[20px] w-full'>
              <div className='flex flex-col gap-y-8 w-full'>
                <div className='flex flex-col gap-y-2 w-full'>
                  <div className='font-bold text-[1.8em] sm:text-[2.2em] 2xl:text-[2.6em] text-white text-left leading-[1em]'>Subscribe to {process.env.REACT_APP_WEBSITE_NAME}</div>
                  <div className='flex flex-col gap-1 items-start italic'>
                    <div>${STANDARD_SUBSCRIPTION_PRICE_MONTHLY}/mo + ${STANDARD_SUBSCRIPTION_ADDITIONAL_USER_PRICE_MONTHLY}/mo for each 
                      <Tooltip tooltipContent={ADDITIONAL_USER_DESCRIPTION}>
                        <div className='underline decoration-dotted underline-offset-4 cursor-help ml-1'>additional user.</div>
                      </Tooltip>
                    </div>
                    <div>Your information is secure and will never be shared.</div>
                  </div>
                </div>
                <div className='flex flex-col gap-y-6'>
                  {/* First and Last name */}
                  <div className='flex gap-x-2'>
                    <div>
                      <label className='block text-sm font-medium mb-1'>First Name</label>
                      <div className='rounded-[12px] border border-[#0000003f] h-[32px] '>
                        <input 
                          value={inputFirstName}
                          className={inputStyle}
                          type='text' 
                          onChange={(event) => { setInputFirstName(event.target.value); }}
                          onKeyDown={(event) => { if(event.key === 'Enter') { requestSignupCode(REQUEST_STANDARD_SIGNUP_CODE); } }}
                        />
                      </div>
                    </div>
                    <div>
                      <label className='block text-sm font-medium mb-1'>Last Name</label>
                      <div className='rounded-[12px] border border-[#0000003f] h-[32px] '>
                        <input 
                          value={inputLastName}
                          className={inputStyle}
                          type='text' 
                          onChange={(event) => { setInputLastName(event.target.value); }}
                          onKeyDown={(event) => { if(event.key === 'Enter') { requestSignupCode(REQUEST_STANDARD_SIGNUP_CODE); } }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Email Input */}
                  <div>
                    <label className='block text-sm font-medium mb-1'>Work Email</label>
                    <div className='rounded-[12px] border border-[#0000003f] h-[32px] '>
                      <input 
                        value={inputEmail}
                        className={inputStyle}
                        type='text' 
                        onChange={(event) => { setInputEmail(event.target.value); }}
                        onKeyDown={(event) => { if(event.key === 'Enter') { requestSignupCode(REQUEST_STANDARD_SIGNUP_CODE); } }}
                      />
                    </div>
                  </div>
                  {/* Company Name Input */}
                  {/*<div>
                    <label className='block text-sm font-medium mb-1'>Company Name</label>
                    <div className='rounded-[12px] border border-[#0000003f] h-[32px] '>
                      <input 
                        value={inputCompanyName}
                        className={inputStyle}
                        type='text' 
                        onChange={(event) => { setInputCompanyName(event.target.value); }}
                        onKeyDown={(event) => { if(event.key === 'Enter') { requestSignupCode(REQUEST_STANDARD_SIGNUP_CODE); } }}
                      />
                    </div>
                  </div>*/}
                  {/* submit email button */}
                  <PushButton 
                    textColor='black'
                    bgColor='#f9a928'
                    hoverBgColor='#f79800'
                    onClick={() => { requestSignupCode(REQUEST_STANDARD_SIGNUP_CODE); }}
                  >
                    Continue
                  </PushButton>
                </div>
              </div>
            </div>

            {/* Back button */}
            <div className='w-full mt-8 pb-5'>
              <button 
                className='group flex justify-center items-center gap-x-2' 
                title='Go Back'
                onClick={() => { 
                  try { setCurrentPage(PAGE_SIGNUP_PLANS); } catch(error) {}
                }}
              >
                <div className='group-hover:hidden'><BackIcon color='#a59e9e' /></div>
                <div className='hidden group-hover:block'><BackIcon color='#fff' /></div>
                <div className='text-[#a59e9e] group-hover:text-white'>Back</div>
              </button>
            </div>
          </div>
        }
        {currentPage === PAGE_STANDARD_LOGIN_CODE &&
          <div className='relative z-[1] grow flex flex-col justify-center items-center max-w-screen-lg w-full mx-auto text-[1.2em] px-2 pb-0 animate-right-fade'>
            <div className='grow flex flex-col justify-center gap-y-6 max-w-[350px]'>
              <div className='text-[1.8em] text-white font-bold text-left'>Check Your Email</div>
              {/* login code input */}
              <div className='max-w-full flex flex-col gap-y-4 mx-auto'>
                <div className='flex flex-col gap-3 mt-[4px]'>
                  <div>
                    <div>We've sent a verification code to</div>
                    <div className='font-bold'>{inputEmail}</div>
                  </div>
                  <div>Enter it below to continue</div>
                </div>
                <div className='font-light opacity-60 mx-auto'>Didn&apos;t receive the code? Check your spam folder or wait up to 2 minutes for delivery.</div>
                <div>
                  <label className='block text-sm font-medium mb-1'>Verification Code</label>
                  <input 
                    ref={standardLoginCodeRef}
                    value={inputLoginCode}
                    className={inputStyle + ' text-center'}
                    type='text' 
                    onChange={(event) => { setInputLoginCode(event.target.value); }}
                    onKeyDown={(event) => { if(event.key === 'Enter') { submitSignupCode(CHECK_STANDARD_SIGNUP_CODE); } }}
                  />
                </div>
                {/* submit login code button */}
                <PushButton 
                  textColor='white'
                  bgColor='#471cff'
                  hoverBgColor='#603aff'
                  onClick={() => { submitSignupCode(CHECK_STANDARD_SIGNUP_CODE); }}
                >
                  Continue
                </PushButton>
                <button 
                  className='mt-2 underline'
                  onClick={() => { 
                    requestSignupCode(REQUEST_STANDARD_SIGNUP_CODE); 
                    setInputLoginCode('');
                    //if(standardLoginCodeRef.current) {
                    //  standardLoginCodeRef.current.select();
                    //}
                  }}
                >
                  Resend code
                </button>
              </div>
            </div>

            {/* Back Button */}
            <div className='pb-5 w-full'>
              <button 
                className='self-start group flex justify-center items-center gap-x-2' 
                onClick={() => { 
                  try { setCurrentPage(PAGE_STANDARD_SIGNUP); } catch(error) {}
                }}
              >
                <div className='group-hover:hidden'><BackIcon color='#a59e9e' /></div>
                <div className='hidden group-hover:block'><BackIcon color='#fff' /></div>
                <div className='text-[#a59e9e] group-hover:text-white'>Back</div>
              </button>
            </div>
          </div>
        }
        {currentPage === PAGE_STANDARD_LOGIN_LINK &&
          <div className='relative z-[1] grow flex flex-col justify-center items-center max-w-screen-lg w-full mx-auto text-[1.2em] px-2 pb-0 animate-right-fade'>
            <div className='grow flex flex-col justify-center gap-y-6 max-w-[350px]'>
              <div className='text-[1.8em] text-white font-bold text-left'>Check Your Email</div>
              <div className='w-[300px] max-w-full flex flex-col gap-y-4 mx-auto'>
                <div>We've sent an email to <b>{inputEmail}</b> containing a secure link to continue the account creation process. Please check your inbox and follow the provided link to continue your account setup.</div>
                <div className='font-light opacity-50 mx-auto'>Didn&apos;t receive the email? Check your spam folder or wait up to 2 minutes for delivery.</div>
              </div>
            </div>
            {/* Back Button */}
            <div className='pb-5 w-full'>
              <button 
                className='self-start group flex justify-center items-center gap-x-2' 
                onClick={() => { 
                  try { setCurrentPage(PAGE_STANDARD_SIGNUP); } catch(error) {}
                }}
              >
                <div className='group-hover:hidden'><BackIcon color='#a59e9e' /></div>
                <div className='hidden group-hover:block'><BackIcon color='#fff' /></div>
                <div className='text-[#a59e9e] group-hover:text-white'>Back</div>
              </button>
            </div>
          </div>
        }
        <div className='z-[1]'>
          <PoweredByBar />
        </div>
        {/* construction site background */}
        <div className='z-[0] absolute top-[0vh] left-[0vw] opacity-[1] pointer-events-none'>
          <ParallaxSection parallaxMultiplier={0.5}>
            {/*<img width='906' height='1000' className='h-[120vh] object-cover object-top' src='/images/constructionSite2.svg' alt='line drawing of a construction site' />*/}
            <img width='1536' height='1024' className='w-[100vw] min-h-[100vh] object-cover object-top' src='/images/constructionSite3.jpg' alt='a construction site' />
            {/* gradient at bottom to fade image into gray background */}
            <div className='absolute bottom-0 left-0 h-[15vh] w-[100vw] bg-gradient-to-t from-[#151515] to-[#15151500]'></div>
          </ParallaxSection>
        </div>
        {/* top right floating logo */}
        <div className='fixed top-[4em] left-[100%] translate-x-[-90%] opacity-[0.10] pointer-events-none'>
          <div className='sm:hidden'><Logo size={250} /></div>
          <div className='hidden sm:block 2xl:hidden'><Logo size={300} /></div>
          <div className='hidden 2xl:block'><Logo size={400} /></div>
        </div>
      </div>
    );
  };

  return (
  <>
    <div className={`relative flex flex-col justify-between bg-[#151515] text-white overflow-hidden`}>
      {/* main content */}
      {currentPage === PAGE_LANDING && getMainPageJSX()}
      {currentPage !== PAGE_LANDING && getSignupPagesJSX()}
    </div>
    {loginDialogueShowing &&
      <div className='relative z-[2]'>
        <LoginDialogue closeDialogue={() => { setLoginDialogueShowing(false); }} />
      </div>
    }
  </>
  );
}

const mapStateToProps = state => { return { // define redux state that will be passed in as props
  _isTouchDevice: state.localEphemeral.isTouchDevice,
  _localEditScheduleId: state.serverSynced.localEditScheduleId,
  _localEditScheduleProjectId: state.serverSynced.localEditScheduleProjectId,
}};
export default connect(mapStateToProps, {setAlert, login, setLoading, siteboardAction})(LandingPage);
